var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.datas.objectInfo && _vm.datas.objectInfo.length == 1)?_c('div',{staticClass:"html_teamInfor",class:_vm.datas.statisticsModels && _vm.datas.statisticsModels.length > 8
      ? 'scrollBox'
      : ''},[_c('div',{staticClass:"all"},[_c('div',{staticClass:"teamImg"},[_c('img',{attrs:{"src":_vm.teamInfor.teamLogo}}),_c('span',{domProps:{"textContent":_vm._s(_vm._valFormatHandler(_vm.teamInfor.teamName))}})]),_vm._l((_vm.datas.statisticsModels),function(item,index){return _c('div',{key:item.statisticalEn,staticClass:"info",class:[
        index % 2 === 1 ? 'gray' : '',
        item.statisticalEn === 'worldRank' ? 'worldRank' : '',
      ]},[_c('div',{staticClass:"info-name",domProps:{"textContent":_vm._s(
          item.statisticalEn === 'worldRank'
            ? _vm._valFormatHandler(item.name, '：')
            : _vm._valFormatHandler(item.name)
        )}}),_c('div',{staticClass:"info-value",domProps:{"textContent":_vm._s(_vm._valFormatHandler(_vm.tableData[item.statisticalEn], item.suffix))}})])})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }